/* Home "Hot Lots" trending carousel.
   Fetches all four rankings once from /api/home/hot-lots and switches tabs
   client-side. Hides the whole section if there's nothing to show. */
(function () {
  'use strict';

  var MHV = window.MHV || {};
  var SERVER_URL = MHV.SERVER_URL || 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';

  var section = document.getElementById('mhv-hotlots');
  var track = document.getElementById('mhv-hotlots-track');
  var tabsEl = document.getElementById('mhv-hotlots-tabs');
  var prevBtn = document.getElementById('mhv-hotlots-prev');
  var nextBtn = document.getElementById('mhv-hotlots-next');
  if (!section || !track) return;

  var data = { trending: [], bids: [], favs: [], views: [] };
  var activeTab = 'trending';
  var loaded = false;
  var auctionEnded = false;   // when true, cards show "Sold for" not "Current bid" (item 12)
  var SPINNER = '<div class="mhv-hl-loading"><span class="mhv-hl-spinner" aria-hidden="true"></span> Loading hot lots…</div>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(n) {
    n = parseFloat(n);
    if (!isFinite(n) || n <= 0) return null;
    return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  // Per-tab the "headline" stat is emphasized; the rest show muted. Bids keep
  // their word; favourites and views are a number beside a glyph ("3 ♥", "57 👁"),
  // the same spelling as the hub card (MHV.countGlyph in mhv-utils-9.js).
  function statLine(lot, tab) {
    var glyph = function (name) {
      return (MHV.icon ? MHV.icon(name, { inline: true, label: name === 'heart' ? 'Favorites' : 'Views' }) : (name === 'heart' ? 'favs' : 'views'));
    };
    var stats = [
      // A BLIND sale shares no bid count — running (lot.blind) or ended (lot.hideBids).
      (lot.blind || lot.hideBids) ? null : { key: 'bids', label: (lot.bids === 1) ? 'bid' : 'bids', val: lot.bids || 0 },
      { key: 'favs', label: glyph('heart'), val: lot.favs || 0 },
      { key: 'views', label: glyph('eye'), val: lot.views || 0 }
    ].filter(Boolean);
    return stats.map(function (s) {
      var hot = (tab === s.key) || (tab === 'trending' && s.key === 'bids');
      return '<span class="mhv-hl-stat' + (hot ? ' is-hot' : '') + '">' +
        '<strong>' + (s.val || 0) + '</strong>\u00a0' + s.label + '</span>';
    }).join('');
  }

  function cardHtml(lot, tab) {
    var url = lot.url || (lot.handle ? '/products/' + lot.handle : '#');
    var img = lot.image
      ? '<img src="' + esc(lot.image) + '" alt="' + esc(lot.title) + '" loading="lazy">'
      : '<div class="mhv-hl-noimg"></div>';
    // Lot numbers always carry leading zeros (house rule): "Lot 007".
    var lotNo = lot.lot == null ? '' : String(lot.lot).trim();
    if (/^\d{1,2}$/.test(lotNo)) lotNo = ('00' + lotNo).slice(-3);
    var lotTag = lotNo ? '<span class="mhv-hl-lot">Lot ' + esc(lotNo) + '</span>' : '';
    var bid = money(lot.currentBid);
    // After the auction ends, a lot with bids shows "Sold for" instead of "Current bid"
    // (item 12); lots with no bids stay "No bids yet".
    var bidLabel = auctionEnded ? 'Sold for' : 'Current bid';
    // An ended sale: the price is the hammer (server reads it from the catalogue); a
    // lot that passed says so rather than "No bids yet".
    var bidRow = lot.blind ? '' : (auctionEnded && lot.passed)
      ? '<div class="mhv-hl-bid mhv-hl-bid--none"><span class="mhv-hl-bid-label">Passed</span></div>'
      : bid
      ? '<div class="mhv-hl-bid' + (auctionEnded ? ' mhv-hl-bid--sold' : '') + '"><span class="mhv-hl-bid-label">' + bidLabel + '</span><span class="mhv-hl-bid-amt">' + bid + '</span></div>'
      : '<div class="mhv-hl-bid mhv-hl-bid--none"><span class="mhv-hl-bid-label">No bids yet</span></div>';
    return '<a class="mhv-hl-card" href="' + esc(url) + '">' +
      '<div class="mhv-hl-media">' + img + lotTag + '</div>' +
      '<div class="mhv-hl-body">' +
        '<div class="mhv-hl-title">' + esc(lot.title) + '</div>' +
        bidRow +
        '<div class="mhv-hl-stats">' + statLine(lot, tab) + '</div>' +
      '</div>' +
    '</a>';
  }

  function render() {
    if (!loaded) { track.innerHTML = SPINNER; return; }   // keep the spinner until data arrives
    var lots = data[activeTab] || [];
    if (!lots.length) { track.innerHTML = ''; return; }
    track.innerHTML = lots.map(function (l) { return cardHtml(l, activeTab); }).join('');
    track.scrollLeft = 0;
    updateArrows();
  }

  function setTab(tab) {
    if (!data[tab]) return;
    activeTab = tab;
    Array.prototype.forEach.call(tabsEl.querySelectorAll('.mhv-hotlots-tab'), function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-tab') === tab);
    });
    render();
  }

  function updateArrows() {
    if (!prevBtn || !nextBtn) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    prevBtn.disabled = track.scrollLeft <= 2;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
    var hideArrows = maxScroll <= 0;
    prevBtn.style.display = hideArrows ? 'none' : '';
    nextBtn.style.display = hideArrows ? 'none' : '';
  }

  function scrollByCards(dir) {
    var card = track.querySelector('.mhv-hl-card');
    var step = card ? (card.offsetWidth + 16) * 2 : 320;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  if (tabsEl) {
    tabsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.mhv-hotlots-tab');
      if (btn) setTab(btn.getAttribute('data-tab'));
    });
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });
  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);

  // The shell + spinner are visible immediately (rendered by Liquid). Once the data
  // arrives, swap the spinner for cards — or hide the whole section if there's nothing.
  fetch(SERVER_URL + '/api/home/hot-lots')
    .then(function (r) { return r.json(); })
    .then(function (res) {
      data = (res && res.lots) || data;
      auctionEnded = !!(res && res.ended);
      loaded = true;
      // The single-signal tabs list only lots that HAVE the thing they rank on, so
      // one can be empty early in a sale (Most Bids before the first bid). Trending
      // is never gated — a fresh auction still fills the front page — so it is
      // normally the tab that stays. Hide empty tabs; open on the first with lots.
      var tabs = ['trending', 'bids', 'favs', 'views'].filter(function (k) { return (data[k] || []).length; });
      if (!tabs.length) { section.hidden = true; return; }
      if (tabsEl) {
        Array.prototype.forEach.call(tabsEl.querySelectorAll('.mhv-hotlots-tab'), function (b) {
          b.hidden = tabs.indexOf(b.getAttribute('data-tab')) < 0;
        });
      }
      if (tabs.indexOf(activeTab) < 0) { setTab(tabs[0]); return; }
      render();
    })
    .catch(function (err) {
      section.hidden = true;   // network/error → don't leave a stuck spinner
      if (window.console) console.warn('Hot lots failed:', err && err.message);
    });
})();
